const initBlock = function( $block ) {
	function setupTeamMembers() {
		const $teamMembers = $block.find( '.team-member' );
		if ( !$teamMembers.length ) {return;}
		$teamMembers.each( function() {
			const $teamMember = $( this );
			$teamMember.hover(
				function() {
					const $this = $( this );
					$this.addClass( 'is-hover' );
				},
				function() {
					const $this = $( this );
					$this.removeClass( 'is-hover' );
				}
			);
		} );
	}

	setupTeamMembers();
};

app.loadBlock( initBlock, 'section-team', '.section-team' );

if ( module.hot ) {
	module.hot.accept();
}
